import { render } from "./CookieSettingsModal.vue?vue&type=template&id=0464f531&scoped=true"
import script from "./CookieSettingsModal.vue?vue&type=script&lang=js"
export * from "./CookieSettingsModal.vue?vue&type=script&lang=js"

import "./CookieSettingsModal.vue?vue&type=style&index=0&id=0464f531&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0464f531"]])

export default __exports__